(function($) {

    FastClick.attach(document.body);

    var hackerList = new List('faq_list', { valueNames: [ 'question' ] });

    $('.nav-top').tinyNav({
        header: 'Hoofdmenu'
    });

    $('#menu-item-1539, .toggle-modal').click(function(e) {
        e.preventDefault();
        $('.modal').toggle();
    });

    $('#Glide').glide({
        type: 'carousel',
        autoplay: false
    });

    $('select').customSelect();

    var output = '';

    $('table').wrap( "<div class='tableWrapper'></div>" );

    $('.search-form').submit(function(e) {
        var input = $(this).find('input');

        if (input.val().length == 0) {
            e.preventDefault();
            $(this).addClass('open');
            input.focus();
        }
    });

    $('.search-form input').focusout(function() {
        if ($(this).val().length == 0) {
            $(this).parent().removeClass('open');
        }
    });

})(jQuery);